import React from "react";
import { Box, Typography } from "@mui/material";
import { IP } from "../../../../internalServer"

function McqResultCard({ data, isCorrect, label }) {

    if (!data) return null;

    const question = data.question;
    const userAnswerKey = data.answer.key;
    const correctAnswerKey = question.correct_answers[0].option_key;

    return (
        <Box sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, mb: 3 }}>
            {/* Question */}
            <Typography variant="h6" gutterBottom>
                {label}. {question.title} (
                <span className="text-primary">{question.correct_score} Marks</span>)
            </Typography>

            {/* Question Attachment */}
            {question?.attachments?.length > 0 && (
                <Box sx={{ my: 2, display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {question?.attachments.map((att, idx) => (
                        <img
                            key={idx}
                            src={IP + att}
                            alt={`question-attachment-${idx}`}
                            style={{
                                maxWidth: "200px",
                                borderRadius: "8px",
                                border: "1px solid #ddd",
                            }}
                        />
                    ))}
                </Box>
            )}
            {/* Options */}
            {question.options.map((opt) => {
                const isCorrect = opt.key === correctAnswerKey;
                const isUser = opt.key === userAnswerKey;

                return (
                    <Box
                        key={opt.key}
                        sx={{
                            p: 1.5,
                            borderRadius: 1,
                            display: "flex",
                            alignItems: "center",
                            mb: 1,
                            bgcolor: isCorrect
                                ? "#e6f4ea" // green background
                                : isUser
                                    ? "#fdecea" // red background
                                    : "#fff",
                            border: isCorrect
                                ? "1px solid #4caf50"
                                : isUser
                                    ? "1px solid #f44336"
                                    : "1px solid #ddd",
                        }}
                    >
                        <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                            {opt.key}.
                        </Typography>
                        <Typography sx={{ flexGrow: 1 }}>{opt.value}</Typography>

                        {isCorrect && (
                            <Typography sx={{ color: "#4caf50", fontWeight: "bold" }}>
                                Correct Answer
                            </Typography>
                        )}
                        {isUser && !isCorrect && (
                            <Typography sx={{ color: "#f44336", fontWeight: "bold" }}>
                                Your Answer
                            </Typography>
                        )}
                        {opt.attachment && (
                            <Box
                                sx={{ mt: 1, display: "flex", gap: 2, flexWrap: "wrap", ml: 4 }}
                            >
                                <img
                                    src={IP + opt.attachment}
                                    alt={`option-${opt.key}-attachment`}
                                    style={{
                                        maxWidth: "100px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </Box>
                        )}
                    </Box>
                );
            })}

            {/* Result */}
            <Typography
                sx={{
                    mt: 2,
                    color: isCorrect ? "green" : "red",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {isCorrect ? "✔ Correct" : "✘ Wrong"}
            </Typography>

            {/* Explanation */}
            <Typography sx={{ mt: 1, color: "gray" }}>
                {question.correct_answers[0]?.reason_for_answer?.explanation ||
                    data.answer.explanation}
            </Typography>
        </Box>
    );
}

export default McqResultCard;
